var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popover',{attrs:{"placement":"top"}},[_c('span',{class:['af-icons', 'af-icons-help', _vm.alignment]}),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }